import Link from './Link';
import { FOOTER_CLASSES } from '../constants/classNames';
import { PUBLISHER_NAME, PUBLISHER_URL, ROUTES, SITE_DOMAIN } from '../constants/config';
import '../styles/SiteFooter.css';

const FOOTER_LINKS = [
  { route: ROUTES.ELEMENTS, label: 'Elements' },
  { route: ROUTES.REACTIONS, label: 'Famous reactions' },
  { route: ROUTES.PARENTS, label: 'Parents & teachers' },
  { route: ROUTES.ABOUT, label: 'About us' },
  { route: ROUTES.CONTACT, label: 'Contact' },
  { route: ROUTES.PRIVACY, label: 'Privacy policy' },
  { route: ROUTES.TERMS, label: 'Terms of use' },
];

export default function SiteFooter() {
  return (
    <footer className={FOOTER_CLASSES.root}>
      <nav className={FOOTER_CLASSES.links} aria-label="Site links">
        {FOOTER_LINKS.map(({ route, label }) => (
          <Link key={route} to={route} className={FOOTER_CLASSES.link}>
            {label}
          </Link>
        ))}
      </nav>
      <p className={FOOTER_CLASSES.text}>
        © {new Date().getFullYear()} {SITE_DOMAIN}. A pretend lab for curious kids. Real chemistry needs a grown-up and safety goggles!
      </p>
      <p className={FOOTER_CLASSES.text}>
        A <a href={PUBLISHER_URL} className={FOOTER_CLASSES.link}>{PUBLISHER_NAME}</a> project.
      </p>
    </footer>
  );
}
